import React from "react";

interface IngresoLoadingProps {
  data: any;
  progress: number;
  handleHideIngreso: any;
  isIngresoHidden: boolean;
  moveIngreso: boolean;
}
declare const window: any;

const IngresoLoading = ({
  data,
  progress,
  handleHideIngreso,
  isIngresoHidden,
  moveIngreso,
}: IngresoLoadingProps) => {
  return (
    <div
      className={!moveIngreso ? "ingreso-sidebar" : "ingreso-sidebar-collapsed"}
    >
      {data?.logos_multiples?.length > 0 ? (
        <div
          className="ingreso-logo-constructora"
          style={{ top: "2%", height: "auto" }}
        >
          <img
            src={
              (window.hybrid
                ? ""
                : "https://s3-umbra-storage-cloud-v2.s3.amazonaws.com/") +
              data.logo_constructora
            }
            alt=""
            className="ingreso-logo-secundario"
          ></img>
          {data?.logos_multiples?.map((logo: any) => (
            <img
              src={
                (window.hybrid
                  ? ""
                  : "https://s3-umbra-storage-cloud-v2.s3.amazonaws.com/") +
                logo.link
              }
              alt=""
              className="ingreso-logo-secundario"
            ></img>
          ))}
        </div>
      ) : null}
      <div
        className="ingreso-logo-constructora"
        style={{ top: data?.logos_multiples?.length > 0 ? "10%" : "5%" }}
      >
        {data?.logos_multiples?.length === 0 ? (
          <img
            src={
              (window.hybrid
                ? ""
                : "https://s3-umbra-storage-cloud-v2.s3.amazonaws.com/") +
              data.logo_constructora
            }
            alt=""
            className="ingreso-logo"
            style={{ marginLeft: "auto", marginRight: "auto" }}
          ></img>
        ) : null}
        <img
          src={
            (window.hybrid
              ? ""
              : "https://s3-umbra-storage-cloud-v2.s3.amazonaws.com/") +
            data.logo_proyecto
          }
          alt=""
          className="ingreso-logo"
          style={{ marginLeft: "auto", marginRight: "auto" }}
        ></img>
      </div>
      <div
        className="nota-lega-container"
        style={{
          color: data.colors ? data.colors.main_text : "",
        }}
      >
        {data.texto_legal}
      </div>
      {
        <div
          className={
            progress < 95
              ? "loading-text-container fade-in"
              : "loading-text-container fade-out"
          }
        >
          Cargando...
        </div>
      }
      {
        <div
          className={
            progress < 95
              ? "loading-container fade-in"
              : "loading-container fade-out"
          }
        >
          <div
            className="loding-progress"
            style={{
              width: progress + "%",
              backgroundColor: data.colors ? data.colors.main_buttons : "",
            }}
          />
        </div>
      }
      {
        <div
          className={
            progress < 95
              ? "loading-progress-number fade-in"
              : "loading-progress-number fade-out"
          }
        >
          {progress}%
        </div>
      }
      {!isIngresoHidden ? (
        <div
          className={
            progress >= 95 ? "enter-btn fade-in" : "enter-btn fade-out"
          }
          style={{
            backgroundColor: data.colors ? data.colors.main_buttons : "",
            color: data.colors ? data.colors.secondary_text : "",
          }}
          onClick={() => {
            handleHideIngreso();
          }}
          data-type={"INGRESO"}
          data-value={"INGRESO"}
        >
          Aceptar y continuar
        </div>
      ) : null}
      <div className="powered-by">
        Powered by ® Umbra 3D Studio - {new Date().getFullYear()}
      </div>
    </div>
  );
};

export default IngresoLoading;
